(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63728],{

/***/ 824972:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/sellers/[sellerId]",
      function () {
        return __webpack_require__(724478);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 724478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ sellers_sellerId_; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./tenants/_template/desktop/sellers/[sellerId].tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




const BlockPage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(19303), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(4545), __webpack_require__.e(38272), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(14249), __webpack_require__.e(57663), __webpack_require__.e(64976)]).then(__webpack_require__.bind(__webpack_require__, 864976)).then((mod)=>mod.BlockPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(864976)
            ]
    }
});
const SearchPage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(19303), __webpack_require__.e(88837), __webpack_require__.e(60687), __webpack_require__.e(37070), __webpack_require__.e(97968), __webpack_require__.e(50643), __webpack_require__.e(16164)]).then(__webpack_require__.bind(__webpack_require__, 325552)).then((mod)=>mod.SearchPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(325552)
            ]
    }
});
const defaultGetServerSideProps = ()=>{
    return {
        props: {}
    };
};
const getServerSideProps = (context)=>{
    var ref, ref1;
    return !(context === null || context === void 0 ? void 0 : (ref = context.req) === null || ref === void 0 ? void 0 : (ref1 = ref.tenantEnv) === null || ref1 === void 0 ? void 0 : ref1.epicPb1887) ? getServerSidePropsBlockPage(context) : defaultGetServerSideProps();
};
const SellerPage = (props)=>{
    const { epicPb1887  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return !epicPb1887 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockPage, _objectSpreadProps(_objectSpread({}, props), {
        forceNoIndex: true
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPage, {
        forceNoIndex: true
    });
};
/* harmony default export */ var _sellerId_ = (SellerPage);

;// CONCATENATED MODULE: ./pages/default/desktop/sellers/[sellerId].tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var sellers_sellerId_ = (_sellerId_);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [93712,49774,92888,40179], function() { return __webpack_exec__(824972); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);